import { useStore } from '@nanostores/react';
import { memo, useCallback } from 'react';
import { workbenchStore } from '~/lib/stores/workbench';
import { classNames } from '~/utils/classNames';

export const InspectorToggle = memo(() => {
  const isInspectorOpen = useStore(workbenchStore.isInspectorOpen);
  const previews = useStore(workbenchStore.previewsStore.previews);

  const hasPreview = previews.length > 0;

  const handleToggleInspector = useCallback(() => {
    const preview = workbenchStore.previewRef?.current;

    if (!preview) {
      return;
    }

    void preview.toggleInspector();
  }, []);

  return (
    <button
      type="button"
      className={classNames(
        'rounded-full px-2 h-7 flex items-center gap-1 text-xs bg-bolt-elements-item-backgroundDefault',
        isInspectorOpen
          ? 'text-bolt-elements-item-contentAccent bg-bolt-elements-item-backgroundAccent'
          : 'text-bolt-elements-textTertiary hover:text-bolt-elements-textPrimary hover:bg-bolt-elements-item-backgroundActive',
      )}
      onClick={handleToggleInspector}
      disabled={!hasPreview}
      aria-pressed={isInspectorOpen}
    >
      <span className="i-ph:cursor-click w-4 h-4" />
      Select
    </button>
  );
});
